// Umami-скрипт подключён в public/index.html. События из кода шлём через
// window.umami; если скрипт не загрузился (блокировщик/оффлайн) — молча пропускаем.
export default function trackUmamiEvent(eventName, eventData) {
  try {
    window.umami?.track(eventName, eventData);
  } catch {}
}
